import {createApp, h} from 'vue'
import {createInertiaApp, Head, Link} from '@inertiajs/inertia-vue3'
import {InertiaProgress} from '@inertiajs/progress'
import {ZiggyVue} from 'ziggy'
import Layout from "@/Shared/Layout"
import {i18nVue} from 'laravel-vue-i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'

createInertiaApp({
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        page.layout = page.layout || Layout
        return page
    },
    title: title => title ? title : 'Lonvel',
    setup({el, App, props, plugin}) {
        createApp({
            render: () => h(App, props)
        })
            .use(plugin)
            .use(ZiggyVue, () => {
                const response = fetch('/api/ziggy');
                return response.toJson()
            })
            .use(VueAxios, axios)
            .use(i18nVue, {
                resolve: (lang) => import(`../../lang/${lang}.json`),
            })
            .component('InertiaHead', Head)
            .component('InertiaLink', Link)
            .mixin({methods: {route}})
            .mount(el)
    },
    visitOptions(options, url) {
        options.preserveScroll = true
        return options
    }
})

InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 0,

    // The color of the progress bar.
    color: '#cc0014',

    // Whether to include the default NProgress styles.
    includeCSS: true, //this

    // Whether the NProgress spinner will be shown.
    showSpinner: false,
})
